const GOOGLE_API_KEY =
    (import.meta.env.VITE_GOOGLE_PLACES_API_KEY as string | undefined) ?? "";

export type StaticMapTreatment = {
    readonly size: string;
    readonly width: number;
    readonly height: number;
    readonly aspectClass: string;
};

export const LISTING_STATIC_MAP = {
    size: "600x240",
    width: 600,
    height: 240,
    aspectClass: "aspect-[5/2]",
} as const satisfies StaticMapTreatment;

export const PROVIDER_STATIC_MAP = {
    size: "600x300",
    width: 600,
    height: 300,
    aspectClass: "aspect-[2/1]",
} as const satisfies StaticMapTreatment;

export function staticMapSrc(
    lat: number | null | undefined,
    lng: number | null | undefined,
    treatment: StaticMapTreatment = LISTING_STATIC_MAP,
): string | undefined {
    if (!GOOGLE_API_KEY) return undefined;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return undefined;
    return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=11&size=${treatment.size}&scale=2&markers=color:0x6876B9%7C${lat},${lng}&key=${GOOGLE_API_KEY}`;
}
